import { openNotification } from "../../globals/Components/Notification/Notificaction";
import { serverMessages } from "../serverMessages";
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { MessageResponse } from "../system/types";
import { AppThunk } from "../thunks";
import { postMedicalOrderResultAPI } from "./restCallPersonal";
import { getMedicalDoctorAttentionAPI } from "./restCallPersonal";
import { getAddressByPersonalRecordAPI, getAllEmailAPI, getAllOrderAtentionAPI, getAllPersonalRecordContainsNameOrDniAPI, getAllPersonalRecordsAPI, getPersonalRecordInformationAPI, getPersonalRecordMedicalInformationAPI, getMedicalOrderResultsByDniAPI, deletePersonalRecordAPI, postPersonalRecordPatientAPI, getAllIdentityPersonalRecordContainsNameOrDniAPI, getInformationServiceAPI, getOrderTableAPI, getResultsLabAPI, postAddressAPI, postEmailAPI, postRegistePersonalRecordAPI, postRegisterLaboratoryAPI, postUploadfilesAPI, putEmailAPI, putLaboratoryProviderOrderAPI, putOrderStatusAPI, putPersonalRecordAPI, putPersonalRecordStatusAPI, getAllCommissionsAPI, postMedicalRecordAPI, getMedicalRecordbyOrderAtentionAPI, getProceduresPerToothAPI, postProcedurePerToothAPI, postEvidencePerToothAPI, getAllOrderAtentionWithStatusAPI,postPathologicalHistoryAPI ,putPathologicalHistoryAPI,getPathologicalHistorybyPersonalIdAPI,deleteEvidenceTreatmentPerToothAPI,
         postTreatmentPlanAPI,postGeneralTreatmentEvidenceAPI,postTreatmentPeerToothAPI,getTreatmentPlanAPI,putProcedurePerToothTreatmentPlanStatusAPI,deleteGeneralEvidenceTreatmentPerToothAPI,putProcedureTreatmentPlanStatusAPI,postDepositAPI,getDepositAPI,getPaymentAPI,postPaymentAPI,postMedicalRecordObservationAPI,putIdentityPersonalRecordStatusAPI,putIdentityPersonalRecordAPI,postIdentityPersonalRecordAPI,getIdentityAllOrderAtentionAPI, putIdentityOrderStatusAPI,postRegisterOrderAttentionAPI, postMedicalRecordOrderAttentionAPI,
         getPaymentmethodsAPI, getServiceRecordOrderResultsAPI, postServiceRecordResultsAPI, putServiceRecordResultsAPI, postOrderAttentionAppointmentAPI, getMedicalRecordOrganizationOrderAttentionsAPI,
         getOrderAttentionInformationServiceAPI,
         getAllCommissionsServicesAPI} from "./restCallPersonal";

export const getServiceRecordOrderResults = (orderAttentionId:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getServiceRecordOrderResultsAPI(orderAttentionId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postServiceRecordResults = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postServiceRecordResultsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Proceso ejecutado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putServiceRecordResults = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putServiceRecordResultsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

  export const getPaymentmethods = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPaymentmethodsAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
    export const postRegisterOrderAttention = (value:Object): AppThunk => async (dispatch) => { 
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postRegisterOrderAttentionAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postMedicalRecordOrderAttention = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postMedicalRecordOrderAttentionAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Atención", "La orden de atención fue aperturada correctamente");
        return responseData.Response ?? true;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postOrderAttentionAppointment = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrderAttentionAppointmentAPI(value);

    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Consulta", "La cita pasó a estado en consulta");
        return responseData.Response ?? true;
    }

    dispatch(toggleLoadingIndicator(false));
};

export const getMedicalRecordOrganizationOrderAttentions = (start: string, end: string, organizationId?: string | null): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getMedicalRecordOrganizationOrderAttentionsAPI(start, end, organizationId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

  export const getIdentityAllOrderAtention = (start:string,end:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getIdentityAllOrderAtentionAPI(start,end);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const putIdentityOrderStatus = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putIdentityOrderStatusAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
    export const putIdentityPersonalRecordStatus = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putIdentityPersonalRecordStatusAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putIdentityPersonalRecord = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putIdentityPersonalRecordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const posIdentityRegistePersonalRecord = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postIdentityPersonalRecordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
     
    export const postMedicalRecordObservation= (value:Object): AppThunk => async (dispatch) => {  
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postMedicalRecordObservationAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
   
    export const getPayments= (orderAttentionCode:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));

    const responseData = await getPaymentAPI(orderAttentionCode);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
    };

    export const postPayment= (value:Object): AppThunk => async (dispatch) => {
        
        dispatch(toggleLoadingIndicator(true));
        dispatch(setMessageResponse(null));    
        const responseData = await postPaymentAPI(value);
        if (responseData.Error !== null) {
            let message: MessageResponse;
            message = serverMessages(responseData);  
            
            dispatch(setMessageResponse(message));
        }
        else if (responseData.StatusCode === 200) {
            dispatch(setMessageResponse(null));    
            dispatch(toggleLoadingIndicator(false));     
            return responseData.Response;
        }
        dispatch(toggleLoadingIndicator(false));
    };

    export const getDeposit= (dni:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));

    const responseData = await getDepositAPI(dni);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

 export const postDeposit= (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postDepositAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

    
    export const putProcedureTreatmentPlanStatus= (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putProcedureTreatmentPlanStatusAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

    export const putProcedurePerToothTreatmentPlanStatus= (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putProcedurePerToothTreatmentPlanStatusAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const deleteGeneralEvidenceTreatmentPerTooth= (medicalRecordId:string,evidenceTreatmentId:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));

    const responseData = await deleteGeneralEvidenceTreatmentPerToothAPI(medicalRecordId, evidenceTreatmentId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

    export const getTreatmentPlan= (dni:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await getTreatmentPlanAPI(dni);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
     
    export const postTreatmentPeerTooth= (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postTreatmentPeerToothAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

 export const postGeneralTreatmentEvidence= (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postGeneralTreatmentEvidenceAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const postTreatmentPlan= (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postTreatmentPlanAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const deleteEvidenceTreatmentPerTooth = (medicalRecordId:string, number:number, evidenceTreatmentId:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));

    const responseData = await deleteEvidenceTreatmentPerToothAPI(medicalRecordId, number, evidenceTreatmentId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPathologicalHistorybyPersonalId = (personalId:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));

    const responseData = await getPathologicalHistorybyPersonalIdAPI(personalId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putPathologicalHistory = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putPathologicalHistoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postPathologicalHistory = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postPathologicalHistoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const postMedicalRecord = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postMedicalRecordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postProcedurePerTooth = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postProcedurePerToothAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postEvidencePerTooth = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postEvidencePerToothAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getProceduresPerTooth = (medicalRecordId:string, number:number, position?:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await getProceduresPerToothAPI(medicalRecordId, number, position);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getMedicalRecordbyOrderAtention= (OrderAttentionCode:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await getMedicalRecordbyOrderAtentionAPI(OrderAttentionCode);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllCommissionsServices = (start:string,end:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllCommissionsServicesAPI( start,end);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllCommissions = (start:string,end:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllCommissionsAPI(start,end);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getAllOrderAtentionWithStatus = (start:string,end:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllOrderAtentionWithStatusAPI(start,end);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllOrderAtention = (start:string,end:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllOrderAtentionAPI(start,end);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const postUploadfiles = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postUploadfilesAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
//


export const putOrderStatus = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putOrderStatusAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const putLaboratoryProviderOrder = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putLaboratoryProviderOrderAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getResultsLab = (personalRecordId:string,orderAttentionId:string,sendEmail:boolean): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getResultsLabAPI(personalRecordId,orderAttentionId,sendEmail);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false)); 
        if(sendEmail){
             openNotification("Envio de correo","Correo se envio correctamente"); 
        }
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getMedicalOrderResultsByDni = (dni:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getMedicalOrderResultsByDniAPI(dni);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getMedicalDoctorAttention = (doctorId:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getMedicalDoctorAttentionAPI(doctorId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postMedicalOrderResult = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postMedicalOrderResultAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrderAttentionInformationService = (dni:string,orderId:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrderAttentionInformationServiceAPI(dni,orderId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getInformationService = (dni:string,orderId:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getInformationServiceAPI(dni,orderId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getOrderTable = (dni:string,startDate:string,endDate:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrderTableAPI(dni,startDate,endDate);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const postRegisterLaboratory = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postRegisterLaboratoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putEmail = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putEmailAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postEmail = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postEmailAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllEmail = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllEmailAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const postAddress = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postAddressAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAddressByPersonalRecord = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAddressByPersonalRecordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const putPersonalRecordStatus = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putPersonalRecordStatusAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putPersonalRecord = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await putPersonalRecordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Proceso ejecutado correctamente"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const postRegistePersonalRecord = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postRegistePersonalRecordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getAllPersonalRecordContainsNameOrDni = (dni?: string, name?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllPersonalRecordContainsNameOrDniAPI(dni, name);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllPersonalRecords = (organizationId?: string | null): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllPersonalRecordsAPI(organizationId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPersonalRecordInformation = (dni: string, organizationId?: string | null): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPersonalRecordInformationAPI(dni, organizationId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPersonalRecordMedicalInformation = (dni: string, organizationId?: string | null): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPersonalRecordMedicalInformationAPI(dni, organizationId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postPersonalRecordPatient = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postPersonalRecordPatientAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Paciente", "Paciente guardado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const deletePersonalRecord = (dni: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deletePersonalRecordAPI(dni);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Paciente", "Paciente inactivado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

// Nueva función para Servicios (Identity API)
export const getAllIdentityPersonalRecordContainsNameOrDni = (dni: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllIdentityPersonalRecordContainsNameOrDniAPI(dni);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
